module.exports = __webpack_public_path__ + "img/b-app.a487daa2.png";